import { KEY } from "@/react/components/table/useTableMutations";
import { HttpMethods } from "@/react/http";
import { createNotifier } from "@/react/notifications";
import { customerBaseApi } from "@/react/services/api/api";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";

const DID_CLEANUP = "did-cleanup";

const getStuckDidsUrl = `dids/stuck-dids`;
const removeDidsUrl = `dids`;

const didCleanupApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getDids: build.query({
      query: () => ({
        url: getStuckDidsUrl,
        method: HttpMethods.GET,
      }),
      providesTags: [DID_CLEANUP],
    }),
    cleanupDids: build.mutation({
      query: (payload) => ({
        url: removeDidsUrl,
        method: HttpMethods.DELETE,
        body: payload.uuids,
      }),
      invalidatesTags: [DID_CLEANUP],
    }),
  }),
});

export const { useGetDidsQuery, useCleanupDidsMutation } = didCleanupApi;

export const handleCleanupResponse = ({
  rowsToDelete,
  setRowsToDelete,
  setData,
  key,
}) =>
  handleMutationResponse({
    rows: rowsToDelete,
    setRows: setRowsToDelete,
    setData,
    responseMappingKey: key,
    idKey: KEY,
    // TODO: Use "fixe" for now, because current logic adds a 'd' at the end in the operation name, that should be corrected
    notifyContent: createNotifier("fixe", "did"),
  });
